/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_LegalInputs */

const cs_property_tab_legal = /** @type {(inputs: Property_Tab_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní`)
};

const en_property_tab_legal = /** @type {(inputs: Property_Tab_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Property_Tab_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_legal = /** @type {((inputs?: Property_Tab_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_legal(inputs)
	return cs_property_tab_legal(inputs)
});